import { Component, OnInit } from '@angular/core';
import { CarService } from '../services/car.service';
interface Person {
  key: string;
  name: string;
  age: number;
  address: string;
}
@Component({
  selector: 'app-carbooking',
  templateUrl: './carbooking.component.html',
  styleUrls: ['./carbooking.component.less']
})
export class CarbookingComponent implements OnInit {
  getFullYear: number = new Date().getFullYear();
  loading = false;
  perPage = 10;
  page = 1;
  visible = false;
  date = null;
  dataCar = null;
  dataBorrowedAt = new Date();
  dataReturnedAt = new Date();
  dataBorrowTime = new Date();
  dataReturnTime = new Date();
  dataReason = '';
  dataDescription = '';
  dataStartat = '';
  dataEndat = '';
  carData:any=[];
  scheduleData:any=[];
  validate = false;
  isVisible:any;
  createModal = false;
  employeeId = JSON.parse(localStorage.getItem("currentUser")).user.employee._id;
  result = false;
  total: number;
  pageIndex: number;
  isCollapsed = false;
  constructor(
    private carService: CarService,
  ) { }

  ngOnInit() {
    this.getCar();
    this.getSchedule();
  }

  getCar(){
    this.carService.getAll(this.perPage, this.page).subscribe((res:any)=>{
      this.carData = res.data.data;
      console.log("carData", this.carData)
    });
  }

  getSchedule(){
    this.carService.getSchedule(this.perPage, this.page).subscribe((res:any)=>{
      this.scheduleData = res.data.data;
      this.total = res.data.data.length;
      console.log("scheduleData", this.scheduleData)
      console.log('this.total', this.total);
      
    });
  }

  toggle(){
    this.visible = !this.visible;
  }
  onChange(result: Date): void {
    console.log('onChange: ', result);
  }
  carbooking(dataCar:any, dataBorrowTime:any, dataBorrowedAt:any, dataReturnTime:any, dataReturnedAt:any, dataReason:any, dataDescription:any, dataStartat:any, dataEndat:any){
    this.loading = true;
    if(dataCar == null || dataBorrowTime == null || dataBorrowedAt == null || dataReturnTime == null || dataReturnedAt == null || dataReason == ''|| dataStartat ==''|| dataEndat == ''){
      this.validate = true;
      this.loading = false;    
    }else{
      this.validate = false;
      const data = {
        "employee": this.employeeId,
        "car": dataCar,
        "borrowed_at": dataBorrowedAt.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
        "returned_at": dataReturnedAt.toLocaleString('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }),
        "borrow_time": dataBorrowTime.toLocaleString('vi-VN', { hour: 'numeric', minute: '2-digit' }),
        "return_time": dataBorrowTime.toLocaleString('vi-VN', { hour: 'numeric', minute: '2-digit' }),
        "reason": dataReason,
        "description": dataDescription,
        "start_at": dataStartat, 
        "end_at": dataEndat
      }
      console.log('data', data)
      this.postRequest(data);
    }
  }
  postRequest(data:any){
    this.result = false;
    this.carService.postRequest(data).subscribe(
      data => {
        this.loading = false;
        this.getSchedule();
        this.result = true;
        this.dataCar = null;
        this.dataBorrowedAt = new Date();
        this.dataReturnedAt = new Date();
        this.dataBorrowTime = new Date();
        this.dataReturnTime = new Date();
        this.dataReason = '';
        this.dataDescription = '';
        this.dataStartat = '';
        this.dataEndat = '';
      },
      error => {
        console.log('error', error)
        this.loading = false;
      });     
  }
  showModal(id:string): void {
    this.isVisible = id ;
  }
  handleCancel(): void {
    this.isVisible = false;
    this.createModal = false;
  }
  handleOk(): void {
    this.isVisible = false;
    this.createModal = false;
  }
  onPageIndexChange($event) {
    // this.leaveService.getAll(this.perPage, $event).subscribe((res:any)=>{
    //   this.loading = false;
    //   this.total = res.data.total;
    //   this.leaveData = res.data.data;
    // });
  }
}
